app.service('reportBug', function (console, loading, front, validate, modal, $global, captchaService, simpleToastr, cookie) {
	var $self, $checkboxBox, $checkboxInput, $errorEmail, $errorFormBox;
	var loadFormHtml = false;

	function callbackOpenSuccess() {
		$errorFormBox = $('#error-form-box', $self)
		$errorSubjectSelect = $('#error-subject', $self);
		$errorEmail = $('#error-mail', $self);
		$checkboxBox = $('.legal-statement-checkbox', $self);
		$checkboxInput = $('input', $checkboxBox);
		$self.on('click', '.js-send-bug', function () {
			$('#error-form', $self).submit();
		});

		validate.task('errorForm', function (data) {
			sendError(data);
		});

		$errorSubjectSelect.on('change', function () {
			let subject = this.value.toLowerCase();
			let $legalContentData = $(`#legal-${subject}`, $self);
			let $legalStatementText = $('#legal-statement-text', $self);

			let label = $legalContentData.text();
			let visible = $legalContentData.data('visible');
			let required = $legalContentData.data('required');
			let emailRequired = this.value != 'CONTENT_VIOLATION_ERROR';

			if (visible) {
				$checkboxBox.addClass('visible-statement');
				$legalStatementText.text(label);
			} else {
				$checkboxBox.removeClass('visible-statement');
			}
			$errorFormBox.attr('data-selected-subject', this.value);
			$errorEmail.required(emailRequired);
			$errorEmail.ignore(!emailRequired);

			$checkboxInput.prop('checked', false);
			$checkboxInput.required(required);
			$checkboxInput.ignore(!required);
		})
		addErrorWarningCaptcha();
	}

	function loadSuccess(html) {
		loading.stop();
		console.log('WYŚWIETLANIE FORMULARZA BŁĘDÓW');
		modal.generate({
			content: html,
			id: 'error-modal',
			header: 'Zgłoś naruszenie w treści <br>lub błąd na stronie',
			callbackOpen: function () {
				$self = $('#error-modal');
				callbackOpenSuccess();
			}
		});
	}
	function addErrorWarningCaptcha() {
		let $captcha = $('#error-form-box', $self).find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function sendError() {
		console.log('WYSYŁANIE FORMULARZA BŁĘDÓW');

		var params = prepareData();
		$('#error-form', $self).serializeArray().forEach(element => {
			params[element.name.replace(/"/g, '')] = element.value;
		});

		$('#errorFormButton', $self).hide();
		loading.start();
		$.ajax({
			type: 'POST',
			url: '/errorWarningLogger.ltr',
			data: params,
			success: function (json) {
				loading.stop();
				if (json.status == 'SUCCESS') {
					console.log('WYSYŁANIE FORMULARZA BŁĘDÓW - OK');
					$('#error-form-box').hide();
					$('#error-form-send').show();
				} else {
					console.log('WYSYŁANIE FORMULARZA BŁĘDÓW - BŁĄD CAPTCHA');
					modal.alert(json.messages, function () {
						modal.open('error-modal');
					});
				}
			},
			error: function () {
				loading.stop();
				console.log('WYSYŁANIE FORMULARZA BŁĘDÓW - ERROR');
			}
		});
	}
	function prepareData() {
		var data = {
			currentUrl: encodeURIComponent(document.location.href),
			userAgent: navigator.userAgent
		};
		if (front.page() == 'product') {
			$.extend(true, data, {
				type: 'PRODUCT_CARD'/*,
				subject:mobile.product.title, 
				code:mobile.product.plu*/
			});
		} else if (front.page() == 'order') {
			$.extend(true, data, {
				type: 'CART',
				cookie: cookie.get("euroCart")/*,
				subject:'Ścieżka zakupowa - etap: ' +mobile.cart.pageType*/
			});
		} else if (front.group() == 'account') {
			$.extend(true, data, {
				type: 'CUSTOMER_ACCOUNT'/*,
				subject:$('#customerMenu h3:first').text() || 'Konto Klienta'*/
			});
		} else if (front.group() === "order" || front.page() == 'guest-kme-login') {
			$.extend(data, {
				type: 'CART'
			});
		} else {
			$.extend(true, data, {
				type: 'OTHER'
			});
		}
		return data;
	}
	function loadForm(data) {
		loading.start();
		// wydzielony endpoint dla zgłaszania błędu dla koszyka RWD
		const dataUrl = (data.type === 'CART' && front.page() != 'to-cart') || front.page() == 'guest-kme-login' ? '/error-warning-for-order.ltr' : '/errorWarning.ltr';
		$.ajax({
			url: dataUrl,
			data: data,
			success: function (html) {
				loadFormHtml = html;
				loadSuccess(html);
			},
			error: function () {
				loading.stop();
				console.log('WYŚWIETLANIE FORMULARZA BŁĘDÓW - ERROR');
			}
		});
	}
	function show() {
		console.log('KLIKNIĘCIE ZGŁOŚ BŁAD');
		var data = prepareData();
		if (data.type) {
			if (loadFormHtml) {
				loadSuccess(loadFormHtml);
			} else {
				loadForm(data);
			}
		} else {
			modal.alert('Brak możliwości raportowania błędu na tej stronie');
		}
	}
	let isOneInit = false;
	function init() {
		if(!isOneInit){
			isOneInit = true;
			$('body').on('click', '.js-report-bug', function (event) {
				show();
			});
		}
	}
	$global('showError', show);
	return {
		init: init
	};
});
